import { Graphics } from 'pixi.js';
import type { World, ComponentStore } from '@ecs/world';
import { DEFAULT_TUNING, type Tuning } from '@game/tuning';
import type { AmmoComponent, CameraResource, EnemyComponent, TransformComponent } from '@game/scenes/characterPrototype/types';
import { randomInRange } from '@game/scenes/characterPrototype/math';

export type EnemySpawnOptions = {
	ammoClipSize: number;
};

export function createSpawnEnemy(options: EnemySpawnOptions) {
	return function spawnEnemy(
		world: World,
		enemies: ComponentStore<EnemyComponent>,
		transforms: ComponentStore<TransformComponent>,
		graphics: ComponentStore<Graphics>,
		ammoGraphics: ComponentStore<Graphics>,
		ammos: ComponentStore<AmmoComponent>,
		stage: import('pixi.js').Application['stage'],
		x: number,
		y: number
	) {
		const tuning = world.getResource<Tuning>('tuning') ?? DEFAULT_TUNING;
		const entity = world.createEntity();
		enemies.set(entity, {
			cooldown: randomInRange(tuning.enemyCooldownMin, tuning.enemyCooldownMax),
			vx: 0,
			vy: 0,
			baseY: y,
			repath: 0,
			desiredX: Number.NaN,
			wanderPhase: Math.random() * Math.PI * 2,
			hadLos: true,
			burstShotsLeft: 0,
			burstTimer: 0
		});
		transforms.set(entity, { x, y });
		const camera = world.getResource<CameraResource>('camera');
		const offsetY = camera ? camera.y : 0;
		const graphic = new Graphics();
		graphic.rect(-tuning.enemySize / 2, -tuning.enemySize / 2, tuning.enemySize, tuning.enemySize);
		graphic.fill({ color: 0xff3b30, alpha: 0.95 });
		graphic.position.set(x, y - offsetY);
		stage.addChild(graphic);
		graphics.set(entity, graphic);

		ammos.set(entity, {
			capacity: options.ammoClipSize,
			remaining: options.ammoClipSize,
			reloadDuration: Math.max(0.05, tuning.enemyReloadDuration),
			reloadRemaining: 0,
			isEnemy: true
		});
		const ammoBar = new Graphics();
		ammoBar.position.set(x, y - offsetY);
		stage.addChild(ammoBar);
		ammoGraphics.set(entity, ammoBar);
	};
}


